import React from 'react';
import { Modal } from './Modal';
import './HelpModal.css';

const getPotentialTier = (potential: number): { label: string, className: string, description: string } => {
    if (potential > 90) return { label: 'ELITE', className: 'potential-elite', description: 'Generational Talent (91+)' };
    if (potential > 85) return { label: 'STAR', className: 'potential-star', description: 'World Class Player (86-90)' };
    if (potential > 80) return { label: 'KEY', className: 'potential-key', description: 'Leading Star Player (81-85)' };
    if (potential > 75) return { label: 'GOOD', className: 'potential-good', description: 'Good Squad Player (76-80)' };
    if (potential > 65) return { label: 'DECENT', className: 'potential-decent', description: 'Decent Squad Player (66-75)' };
    return { label: 'AVG', className: 'potential-average', description: 'Average Player (<=65)' };
};

const POTENTIAL_TIERS = [
    getPotentialTier(91), getPotentialTier(86), getPotentialTier(81),
    getPotentialTier(76), getPotentialTier(66), getPotentialTier(65)
];

interface PotentialInfoModalProps {
    isOpen: boolean;
    onClose: () => void;
    currentPotential?: number;
}

export const PotentialInfoModal: React.FC<PotentialInfoModalProps> = ({ isOpen, onClose, currentPotential }) => {
    const currentTier = currentPotential !== undefined ? getPotentialTier(currentPotential) : null;

    return (
        <Modal isOpen={isOpen} onClose={onClose} className="help-modal">
            <h2>Potential Tiers Explained</h2>
            <p>Potential indicates a player's maximum possible skill rating.</p>
            <p>A higher potential means they have more room to grow into a star player.</p>
            <ul style={{ listStyle: 'none', padding: 0, marginTop: '16px' }}>
                {POTENTIAL_TIERS.map(tier => (
                    <li key={tier.label} className={`help-modal-row ${currentTier?.label === tier.label ? 'highlight-row' : ''}`}>
                        <span className={`potential-badge ${tier.className}`} style={{ flexShrink: 0 }}>{tier.label}</span>
                        <span>{tier.description}</span>
                    </li>
                ))}
            </ul>
            <div className="modal-actions">
                <button className="button" onClick={onClose}>Close</button>
            </div>
        </Modal>
    );
};
